import script from "./AnnualHealthAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualHealthAssessmentCompleted.vue?vue&type=script&setup=true&lang=js"

import "./AnnualHealthAssessmentCompleted.vue?vue&type=style&index=0&id=7c43759f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c43759f"]])

export default __exports__